import React from 'react';

import PropTypes from 'prop-types';

import axios from 'axios';
import qs from "qs"; //post to php w/o file_get_contents('php://input');

import { Loader } from 'semantic-ui-react'

import {
	Button,
	Form,
	Input,
	Icon,
  } from "semantic-ui-react";

export default class ContactConfirm extends React.Component {
	
	static propTypes = {	
	appState: PropTypes.object.isRequired,
	appStateUpdate: PropTypes.func.isRequired,
	callURL: PropTypes.string.isRequired,
	}

	constructor(props) {
	super(props);
	
	this.devMode = props.appState.devMode;
	
	this.serverCalled = false;
	this.axiosConfig = {
	withCredentials: true,
	credentials: 'include',
	timeout: 10000,
	headers: {
		'Accept': 'application/json',
		'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
		'X-WP-Nonce' : props.appState.session.nonce, 
			}
	}
	
	this.state = {
		 info: 'Confirming contact..',
		 confirmed: false,
		 found: false,
		 confirmation: '',
	 	};
	 
	}
		
	serverCall() {
		const { props } = this;
		const self = this;
	
		const params = qs.stringify( { contact_id: props.appState.contact_id, confirm: props.appState.confirm, ticket: props.appState.ticket_id } );
		
		if (this.devMode) console.log('VideoWhisper/screens/ContactConfirm serverCall', props.callURL, params);
	
		axios.defaults.withCredentials = true;
		axios.post(props.callURL, params, this.axiosConfig)
			.then(function (response) {
				self.serverProcess(response);
			})
			.catch(this.serverError.bind(this));
			
		this.serverCalled = true;
		this.loading = true;
	}
	

	// Helper function to safely call gtag with retry limit
  safeTrackEvent(eventName, params, attempt = 0) {
    const maxAttempts = 2; // Maximum number of attempts to check for gtag
	if (this.devMode) console.log('VideoWhisper/screens/ContactConfirm safeTrackEvent:', eventName, params, attempt);

    if (typeof window.gtag === 'function') {
      // gtag is defined, so you can safely track the event
      window.gtag('event', eventName, params);
	  if (this.devMode) console.log('VideoWhisper/screens/ContactConfirm safeTrackEvent: SENT', eventName, params, attempt);
    } else if (attempt < maxAttempts) {
      // gtag isn't defined yet, and we haven't reached the max attempts
      setTimeout(() => this.safeTrackEvent(eventName, params, attempt + 1), 500);
    } else {
      // Maximum attempts reached, could log this or handle as needed
      if (this.devMode) console.error('VideoWhisper/screens/ContactConfirm safeTrackEvent: gtag not available after multiple attempts');
    }
  }

    serverProcess(response) {
		if (this.devMode) console.log('VideoWhisper/screens/ContactConfirm serverProcess:', response, this.state);
		
		const data = response.data;
		if (!data) return;

		const { props } = this;
		
		if (data.info) this.setState({info: data.info, confirmed: data.confirmed, found: data.found });

		if (data.confirmed) 
		{
			if (props.appState.config.gtag.contactConfirm)
			this.safeTrackEvent('conversion', {
				'send_to': props.appState.config.gtag.contactConfirm,
				'event_category': 'VideoWhisper Support',
				'event_label': 'Contact Confirmed',
				'value': 10
				}, 0);

			let stateUpdate = {contactConfirmed: true, contact: data.contact, session: data.session};
			if (data.ticket) 
				{
					stateUpdate.ticket_id = data.ticket; //ticket also got opened
					stateUpdate.pin = data.pin; //ticket access pin
				
					if (props.appState.config.gtag.conversation)
						this.safeTrackEvent('conversion', {
							'send_to': props.appState.config.gtag.conversation,
							'event_category': 'VideoWhisper Support',
							'event_label': 'New Conversation',
							'value': 20
							}, 0);
				}

			if (data.gtag) //safeTrackEvent for all properties as gtag.[formname][gtagvalue]
				{
					Object.keys(data.gtag).forEach((key) => {
						this.safeTrackEvent('conversion', {
							'send_to': data.gtag[key],
							'event_category': 'VideoWhisper Support',
							'event_label': 'Form ' + key,
							'value': 10
							}, 0);
					});
				}

			this.props.appStateUpdate(stateUpdate, {screen: true});	
		} 

		this.loading = false;
	}
	
	serverError(error) {	
		console.log('VideoWhisper/screens/ContactConfirm serverError:', error);
		
		this.props.appStateUpdate({contactConfirmed: false }, {screen: true});
		
		this.loading = false;
	}


	txt = (text) => {
		//handle text translations from appState.config
		const { props } = this;
		if (!props.appState.config) return text;
		if (!props.appState.config.text) return text;
	
		if (text in props.appState.config.text)
		  return props.appState.config.text[text];
		return text;
	  };

	  
	onChange = (event, data) => {
		const value = data.type === "checkbox" ? data.checked : data.value;
		const name = data.name;
	
		this.setState(
		  {
			[name]: value,
		  },
		); 
	
	  };

	  onSubmitConfirm = (e) => {
		e.preventDefault();
	
		if (this.devMode)
		console.log("VideoWhisper/screen/contactConfirm onSubmitConfirm", this.state);
	
		this.props.appStateUpdate({ 
		  confirm: this.state.confirmation });

		//wait and run this.serverCall()
		setTimeout(() => { this.serverCall(); }	, 500);

	  };
	
	
	render ()
	{
		const { state, txt, onChange } = this;
		this.devMode = this.props.appState.devMode;
		
		if (!this.serverCalled) this.serverCall();

		let retryCode = '';
		if (state.found && !state.confirmed) {
			retryCode = <Form onSubmit={this.onSubmitConfirm} key="retryForm">
			<Form.Field>
				<label>
				  <Icon name="key" /> {txt("Confirmation Code")}
				</label>
				<Input
				  name="confirmation"
				  placeholder={txt("Confirmation Code")}
				  value={state.confirmation}
				  onChange={onChange}
				/>
			  </Form.Field>
			  <Button type="submit" disabled={state.confirmation.length <3}>
				{txt("Confirm")}
			  </Button>
			</Form>      
		}
		
		return (
			<div>
				{!state.confirmed && this.loading ? <Loader active inline className="slow red" /> : '' }
				<br/>{state.info}
				{retryCode}
			</div>
		) 
	}
}